function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 18,
  r: 17,
  stroke: "#fff",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M23.935 17.708l-10.313 6.033V11.676z"
}));

function SvgPlayButtonIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    preserveAspectRatio: "xMidYMin slice"
  }, props), _ref);
}

export default "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 36 36' preserveAspectRatio='xMidYMin slice' width='100%25' %3E %3Cg fill='none' fill-rule='evenodd'%3E %3Ccircle cx='18' cy='18' r='17' stroke='%23fff' stroke-width='2' /%3E %3Cpath fill='%23fff' d='M23.935 17.708l-10.313 6.033V11.676z' /%3E %3C/g%3E %3C/svg%3E";
export { SvgPlayButtonIcon as ReactComponent };